module.exports = __webpack_public_path__ + "img/mfhq_icon.86de8dd7.svg";